import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { IconButton, Stack, Typography } from '@mui/material';
import classnames from 'classnames';
import React, { memo, useMemo, useRef, useState } from 'react';
import useBackwardsCompatible from '../../../../../hooks/useBackwardsCompatible';
import theme from '../../../../../theme';
import { Dashboard } from '../../../../../types/files';
import SelectDealSourceModalNew from '../../../../modals/home-table-view/SelectDealSourceModalNew';
import DealSourceModal from '../../../../modals/tables/dashboards/rows/DealSourceModal';
import useStyles from "../styles";

const SourceCell: React.FC<{ dashboard: Dashboard, expander?: boolean }> = ({ dashboard, expander }) => {
    const classes = useStyles();
    const { dashboardSource } = useBackwardsCompatible();
    const [fieldHover, setFieldHover] = useState<boolean>(expander || false);
    const [editModalOpen, setEditModalOpen] = useState<boolean>(false);
    const [viewModalOpen, setViewModalOpen] = useState<boolean>(false);
    const dealSourceRef = useRef<HTMLElement>(null);

    const source = useMemo(() => dashboardSource(dashboard), [dashboard, dashboardSource]);
    const initials = useMemo(() =>
        source?.name ? source.name.split(' ').slice(0, 2).map(word => word.charAt(0).toUpperCase()).join('') : ''
    , [source]);

    return (<>
        <Stack width="100%" ref={dealSourceRef} onMouseLeave={() => setFieldHover(expander || false)}>
            <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%"
                onMouseEnter={() => setFieldHover(true)}>
                <Stack direction="row" spacing={1} alignItems="center" justifyContent="flex-start">
                    {(!!source?.name || !!source?.email) ? (<>
                        {!!initials && (
                            <Stack alignItems="center" justifyContent="center" p={2} width={32} height={32}
                                sx={{ borderRadius: 4, background: 'linear-gradient(90deg, #60a5fa 0%, #2563eb 100%)' }}>
                                <Typography fontSize="0.75rem" fontWeight={600} fontFamily="Lato" color="#fff">
                                    {initials || ''}
                                </Typography>
                            </Stack>
                        )}
                        <Stack direction="column" alignItems="flex-start" justifyContent="center">
                            {!!source?.name && (
                                <Typography fontFamily="Lato"
                                    fontWeight={expander ? 700 : 400}
                                    fontSize="0.95rem"
                                    color="#334155"
                                    onClick={() => setViewModalOpen(true)}
                                    sx={{ "&:hover": { textDecoration: expander ? 'none' : 'underline' }, cursor: 'pointer' }}>
                                    {source?.name}
                                </Typography>
                            )}
                        </Stack>
                    </>) : expander ? (
                        <Typography fontSize={15} fontWeight={500}>
                            {'No deal source'}
                        </Typography>
                    ) : (
                        <Typography className={classnames(classes.label, classes.sublabel)} pl={4}>
                            {'No deal source'}
                        </Typography>
                    )}
                </Stack>
                {fieldHover && (
                    <Stack direction="row" spacing={1} alignItems="stretch" justifyContent="flex-end">
                        <IconButton disableRipple
                            onClick={() => setEditModalOpen(true)}
                            sx={{ padding: 'unset !important'}}>
                            <ExpandMoreIcon className={classes.icon} sx={{ fill: theme.colors.neutral['500'] }} />
                        </IconButton>
                    </Stack>
                )}
            </Stack>
        </Stack>
        {editModalOpen && (
            <SelectDealSourceModalNew
                open={editModalOpen}
                dashboard={dashboard}
                anchorElement={dealSourceRef.current}
                onClose={() => setEditModalOpen(false) } />
        )}
        {viewModalOpen && (
            <DealSourceModal
                open={viewModalOpen}
                dashboard={dashboard}
                anchorElement={dealSourceRef.current}
                onClose={() => setViewModalOpen(false)} />
        )}
    </>);
}

export default memo(SourceCell);
